{
  "meta": {
    "industry": "Media",
    "fiscalYear": "FY2026",
    "currency": "USD"
  },
  "charts": {
    "monthlyActiveViewers": {
      "type": "bar",
      "title": "Monthly Active Viewers (M)",
      "containerClass": "chartCard",
      "data": [
        { "month": "Feb", "viewers": 12.4 },
        { "month": "Mar", "viewers": 13.1 },
        { "month": "Apr", "viewers": 13.8 },
        { "month": "May", "viewers": 14.6 },
        { "month": "Jun", "viewers": 15.2 },
        { "month": "Jul", "viewers": 16.0 },
        { "month": "Aug", "viewers": 15.6 },
        { "month": "Sep", "viewers": 14.9 },
        { "month": "Oct", "viewers": 15.4 }
      ],
      "xKey": "month",
      "yKey": "viewers",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [4, 4, 0, 0],
      "heightPercent": 85,
      "tooltip": { "suffix": "M viewers", "decimals": 1 }
    },
    "audienceSplit": {
      "type": "pie",
      "title": "Audience Split: Subscribers vs Ad-Supported",
      "containerClass": "chartCard",
      "data": [
        { "name": "Subscribers", "value": 42, "color": "hsl(202, 100%, 50%)" },
        {
          "name": "Ad-supported",
          "value": 58,
          "color": "hsl(214, 32%, 75%)"
        }
      ],
      "tooltip": { "suffix": "%", "includeLabel": true },
      "layout": "side",
      "legend": {
        "items": [
          { "text": "Subscribers: 42% (~6.5M)", "dotClass": "secondary" },
          { "text": "Ad-supported: 58% (~8.9M)", "dotClass": "border" }
        ]
      }
    },
    "topSeries": {
      "type": "bar-horizontal",
      "title": "Top Series by Watch Hours (Q4, M)",
      "containerClass": "chartCardSmall",
      "data": [
        { "title": "Midnight Dispatch", "hours": 38 },
        { "title": "Signal Room", "hours": 31 },
        { "title": "Atlas Live", "hours": 27 }
      ],
      "categoryKey": "title",
      "valueKey": "hours",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [0, 4, 4, 0],
      "height": 180,
      "yAxisWidth": 110,
      "tooltip": { "suffix": "M hours" }
    },
    "completionRate": {
      "type": "pie",
      "title": "Completion Rate",
      "containerClass": "chartCardSmall",
      "data": [
        { "name": "Completed", "value": 64, "color": "hsl(142, 76%, 36%)" },
        { "name": "Dropped", "value": 36, "color": "hsl(0, 84%, 60%)" }
      ],
      "tooltip": { "suffix": "%", "includeLabel": true },
      "layout": "side",
      "flexClass": "chartFlex chartHeight44",
      "legend": {
        "size": "small",
        "items": [
          { "text": "Completed: 64%", "color": "hsl(142, 76%, 36%)" },
          { "text": "Dropped: 36%", "color": "hsl(0, 84%, 60%)" }
        ]
      }
    },
    "topCreators": {
      "type": "bar",
      "title": "Top Creators by Weekly Viewers (M)",
      "containerClass": "chartCardSmall gridSpan2",
      "data": [
        { "name": "Studio Lumen", "value": 5.2 },
        { "name": "Creator Nova", "value": 4.8 },
        { "name": "Pulse Media", "value": 4.1 }
      ],
      "xKey": "name",
      "yKey": "value",
      "barColor": "hsl(142, 76%, 36%)",
      "barRadius": [4, 4, 0, 0],
      "height": 180,
      "tooltip": { "suffix": "M", "decimals": 1 },
      "legend": { "show": true },
      "barName": "Weekly viewers (M)"
    }
  },
  "conversations": [
    {
      "question": "how are monthly active viewers trending this year",
      "pauseAfterResponseMs": 3000,
      "blocks": [
        {
          "type": "chart",
          "chartId": "monthlyActiveViewers",
          "delayMs": 1600
        },
        {
          "type": "paragraph",
          "text": "MAUs rose from 12.4M in Feb to 15.4M in Oct (+24%). The peak was 16.0M in Jul, followed by a dip in Aug/Sep before rebounding in Oct.",
          "delayMs": 0
        }
      ]
    },
    {
      "question": "what share is subscribers vs ad-supported",
      "pauseAfterResponseMs": 3000,
      "blocks": [
        { "type": "chart", "chartId": "audienceSplit", "delayMs": 2000 },
        {
          "type": "paragraph",
          "text": "In Oct (15.4M MAUs), subscribers are 42% (~6.5M) and ad-supported is 58% (~8.9M).",
          "delayMs": 0
        }
      ]
    },
    {
      "question": "how are our flagship shows performing",
      "blocks": [
        { "type": "chart", "chartId": "topSeries", "delayMs": 1250 },
        { "type": "chart", "chartId": "completionRate", "delayMs": 2250 },
        { "type": "chart", "chartId": "topCreators", "delayMs": 1250 },
        {
          "type": "heading",
          "text": "Flagship Performance Summary",
          "delayMs": 0
        },
        {
          "type": "paragraph",
          "text": "The top three series generated 96M watch hours in Q4, with a 64% completion rate. Top creators average 4.1–5.2M weekly viewers, led by Studio Lumen.",
          "delayMs": 0
        }
      ]
    }
  ]
}
